import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_SCHEDULED_MAINTENANCE_TABLE = 'FETCH_SCHEDULED_MAINTENANCE_TABLE'
export const RECEIVE_SCHEDULED_MAINTENANCE_TABLE = 'RECEIVE_SCHEDULED_MAINTENANCE_TABLE'
export const FAILED_SCHEDULED_MAINTENANCE_TABLE = 'FAILED_SCHEDULED_MAINTENANCE_TABLE'

export function fetchScheduledMaintenanceById(id){


    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SCHEDULED_MAINTENANCE_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SCHEDULED_MAINTENANCE_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id:id
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_SCHEDULED_MAINTENANCE_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchScheduledMaintenance(){


    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SCHEDULED_MAINTENANCE_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SCHEDULED_MAINTENANCE_LIST_URL,
            headers: {
                Authorization: auth
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_SCHEDULED_MAINTENANCE_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchScheduledMaintenanceWorkshop(status){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            let id_company = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
                id_company = authStore.authData.result.id_company;
            }
        dispatch({type: FETCH_SCHEDULED_MAINTENANCE_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SCHEDULED_MAINTENANCE_WORKSHOP_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                status:status
            }
        })
        .then((response) => {
            let responseEdited = response
            responseEdited.data.result = response.data.result.filter(d =>
                d.id_company !==  id_company
            )
            dispatch( {
                type: RECEIVE_SCHEDULED_MAINTENANCE_TABLE,
                payload: responseEdited.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchScheduledMaintenanceWorkshopById(id){

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_SCHEDULED_MAINTENANCE_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.SCHEDULED_MAINTENANCE_WORKSHOP_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id:id
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_SCHEDULED_MAINTENANCE_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SCHEDULED_MAINTENANCE_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}